let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hzOpS")).then(() => parcelRequire('eyIaY'));